import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Box, Card, CardActionArea, CardContent, Typography, Grid, CircularProgress } from "@mui/material";
import GavelIcon from "@mui/icons-material/Gavel";
import FlagIcon from "@mui/icons-material/Flag";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import StoreIcon from "@mui/icons-material/Store";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { getAdminDashboard } from "../../utility/httpActions/adminActions";
import { frontendRoutes } from "../../utility/frontendRoutes";

const statCards = [
  { key: "openDisputes", label: "Open Disputes", icon: <GavelIcon fontSize="large" color="error" />, to: frontendRoutes.ADMIN_DISPUTES },
  { key: "pendingReports", label: "Pending Reports", icon: <FlagIcon fontSize="large" color="warning" />, to: frontendRoutes.ADMIN_REPORTS },
  { key: "suspendedUsers", label: "Suspended Users", icon: <PersonOffIcon fontSize="large" color="action" />, to: frontendRoutes.ADMIN_USERS },
  { key: "suspendedShops", label: "Suspended Shops", icon: <StoreIcon fontSize="large" color="action" />, to: frontendRoutes.ADMIN_SHOPS },
  { key: "pendingVerifications", label: "Pending Verifications", icon: <VerifiedUserIcon fontSize="large" color="info" />, to: frontendRoutes.ADMIN_VERIFICATIONS },
];

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["admin-dashboard"], queryFn: getAdminDashboard });

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={3}>
        Dashboard
      </Typography>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Grid container spacing={2}>
          {statCards.map(({ key, label, icon, to }) => (
            <Grid item xs={12} sm={6} md={3} key={key}>
              <Card variant="outlined">
                <CardActionArea onClick={() => navigate(to)}>
                  <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, py: 3 }}>
                    {icon}
                    <Typography variant="h4" fontWeight={700}>
                      {data?.[key] ?? "-"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {label}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      <Typography variant="h6" fontWeight={700} mt={4} mb={2}>
        Quick links
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Card variant="outlined">
            <CardActionArea onClick={() => navigate(frontendRoutes.ADMIN_FEATURE_FLAGS)}>
              <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, py: 3 }}>
                <ToggleOnIcon fontSize="large" color="primary" />
                <Typography variant="body1" fontWeight={600}>
                  Feature Flags
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Turn features on or off
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboard;
